import styled from 'styled-components';

export const CancelAction = styled.div`
  align-items: center;
  display: flex;
  padding: 0 30px;
  border-bottom: none;
  color: var(--colors-neutral-gray-5);
  font-size: 14px;
  cursor: pointer;
  height: 56px;
`;

export const CancelOrderText = styled.span`
  color: var(--colors-primary-blue-2);
`;
